function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCurve = function SvgCurve(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.56 41.56"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 41.56v-19.4c12.22 0 22.16-9.94 22.16-22.16h19.4c0 22.92-18.65 41.56-41.56 41.56",
    style: {
      fill: "#e3ff40"
    }
  }));
};
export default SvgCurve;